import { render } from "./ResourceShareDialog.vue?vue&type=template&id=2831a4ee"
import script from "./ResourceShareDialog.vue?vue&type=script&lang=ts"
export * from "./ResourceShareDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script